/**
 * House Pick categories and hands. User goes through each category;
 * for each category a random hand (4 options) is shown. User can House Pick at any time.
 */

export const HOUSE_PICK_CATEGORIES = [
  {
    id: "cuisine",
    label: "Cuisine",
    hands: [
      ["Italian", "Sushi", "Tacos", "Steakhouse"],
      ["Pizza", "Thai", "Mediterranean", "Burgers"],
      ["Chinese", "Indian", "Vietnamese", "Korean"],
      ["Seafood", "BBQ", "Ramen", "Dim Sum"],
      ["French", "Spanish", "Greek", "Middle Eastern"],
      ["Mexican", "Japanese", "American", "Farm to Table"],
      ["Vegan", "Healthy Bowls", "Comfort Food", "Street Food"],
      ["Coffee", "Dessert", "Wine Bar", "Brunch Cafe"],
    ],
  },
  {
    id: "occasion",
    label: "Occasion",
    hands: [
      ["Date Night", "Happy Hour", "Brunch", "Late Night"],
      ["Celebration", "Birthday Dinner", "Anniversary", "Special Occasion"],
      ["Group Dinner", "Girls Night", "Double Date", "Casual Catch Up"],
      ["Work Lunch", "Client Dinner", "Team Outing", "Networking Spot"],
      ["Quick Bite", "Solo Bite", "Family Dinner", "Pre-Game"],
      ["Post-Game", "After Party", "Sunday Reset", "Out of Town Guests"],
    ],
  },
  {
    id: "vibe",
    label: "Vibe",
    hands: [
      ["Romantic", "Cozy", "Trendy", "Lively"],
      ["Upscale", "Casual", "Chill", "Social"],
      ["Hidden Gem", "Neighborhood Spot", "Modern", "Classic"],
      ["High Energy", "Low Key", "Polished", "Divey"],
      ["Scenic", "Intimate", "Bougie", "Laid Back"],
    ],
  },
  {
    id: "feature",
    label: "Feature / Experience",
    hands: [
      ["Outdoor Seating", "Rooftop", "Waterfront", "Scenic Views"],
      ["Live Music", "DJ", "Jazz", "Entertainment"],
      ["Craft Cocktails", "Wine Focused", "Brewery", "Mocktails"],
      ["Chef Tasting", "Tasting Menu", "Omakase", "Small Plates"],
      ["Good for Groups", "Private Room", "Reservations Easy", "Walkable"],
      ["No Reservation Needed", "Open Late", "Fast Service", "Dog Friendly"],
      ["Patio Heaters", "Easy Parking", "Worth the Drive", "Trending Now"],
    ],
  },
  {
    id: "budget",
    label: "Budget / Price",
    hands: [
      ["Budget Friendly", "Mid Range", "Upscale", "Fine Dining"],
      ["Great Value", "Splurge Worthy", "Happy Hour Deals", "Prix Fixe"],
      ["Under $20", "$20-$40", "$40-$75", "$75+"],
    ],
  },
  {
    id: "dietary",
    label: "Dietary",
    hands: [
      ["Vegan Friendly", "Vegetarian Friendly", "Gluten Free Options", "Dairy Free Options"],
      ["Healthy Options", "High Protein", "Light Fare", "Indulgent"],
    ],
  },
];

/** Shuffle array (Fisher–Yates). Returns new array. */
function shuffleArray(arr) {
  const out = [...arr];
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}

/** Get 4 options chosen at random from the category's full pool (all hands combined). */
export function getRandomHandForCategory(category) {
  const pool = category.hands.flat();
  const shuffled = shuffleArray(pool);
  return shuffled.slice(0, 4);
}

/** Get category order shuffled (so user sees categories in random order). */
export function getShuffledCategoryOrder() {
  return shuffleArray(HOUSE_PICK_CATEGORIES.map((_, i) => i));
}
